import { utils } from '@sfaas/util';

export default {
	plants_: state => {
		const { plants } = state.selectOptions;
		return plants;
	},

	serviceKinds_: state => {
		const { serviceKinds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...serviceKinds];
	},

	procTypes_: state => {
		const { procTypes } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...procTypes];
	},

	procKinds_: state => {
		const { procKinds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...procKinds];
	},

	// outDevs_: state => {
	// 	const { outDevs } = state.selectOptions;
	// 	return outDevs;
	// },

	// inDevs_: state => {
	// 	const { inDevs } = state.selectOptions;
	// 	return inDevs;
	// },

	plantCd_: state => {
		const { plantCd } = state.searchParams;
		return plantCd;
	},

	serviceKind_: state => {
		const { serviceKind } = state.searchParams;
		return serviceKind;
	},

	procType_: state => {
		const { procType } = state.searchParams;
		return procType;
	},

	procId_: state => {
		const { procId } = state.searchParams;
		return procId;
	},

	procName_: state => {
		const { procName } = state.searchParams;
		return procName;
	},

	show_: state => {
		const { show } = state.popupParams;
		return show;
	},

	urlSearchParams_: state => {
		const { searchParams, pagingInfo } = state;
		const urlSearchParams = new URLSearchParams();
		Object.keys(searchParams).forEach(key => {
			const value = searchParams[key];
			if (!utils.$sf_isNull(value) && !utils.isUndefined(value) && !value.includes('ALL')) {
				urlSearchParams.set(key, value);
			}
		});

		// TODO
		Object.keys(pagingInfo).forEach(key => {
			const validKeys = ['currentPage', 'pageUnit'];
			const value = pagingInfo[key];
			if (validKeys.includes(key)) {
				urlSearchParams.set(key, value);
			}
		});
		return urlSearchParams.toString();
	},

	totalSize_: state => {
		const { pagingInfo } = state;
		const { totalSize } = pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pagingInfo } = state;
		const { pageUnit } = pagingInfo;
		return pageUnit;
	}
};
